export const InputTextDT = {
	inputtext: {
		fullWidth: '100%',
		css: ({ dt }) => `
          .p-inputtext__full-width {
              width: ${dt('inputtext.full.width')};
          }
        `,
	},
};
